import ITooltip from '../../../ITooltip'
import IconButton from '@mui/material/IconButton'
import cancelIcon from '../../../Icons/svg/cancel.svg'
import {DIV} from './styles'

const CancelIconButton = ({className, onClick}) => {
    return (
        <DIV className={className}>
            <ITooltip placement="top" content="Delete" >
                <IconButton onClick={onClick}>
                    <img src={cancelIcon} alt={'Delete'} />
                </IconButton>
            </ITooltip>
        </DIV>
    )
}

export default CancelIconButton
